define('home/views/NotificationCardReplyView',[
    'backbone',

    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',
    'home/mixins/withSubviews',

    'home/views/PostActivityCollectionView',

    'home/templates/notificationCardReply',
], function (
    Backbone,

    ActivityCardView,
    withReason,
    asNotificationCard,
    withSubviews,

    PostActivityCollectionView,

    notificationCardReplyTemplate
) {
    'use strict';


    var NotificationCardReplyView = ActivityCardView.extend({
        className: 'card-notif-reply',

        template: notificationCardReplyTemplate,

        regions: {
            postsRegion: '[data-role=post]',
        },

        onRender: function () {
            this.activateRegion(this.postsRegion, this.createPostCollectionView);
        },

        createPostCollectionView: function () {
            return new PostActivityCollectionView({
                collection: new Backbone.Collection(this.model.activities),
            });
        },
    });


    var proto = NotificationCardReplyView.prototype;
    withReason.call(proto);
    asNotificationCard.call(proto);
    withSubviews.call(proto);

    return NotificationCardReplyView;
});

